import $ from "jquery"

// Talent section
document.getElementById('showMoreBtn').addEventListener('click', function() {
    var moreContent = document.getElementById('moreContent')
    var showMoreBtn = document.getElementById('showMoreBtn')
    if (moreContent.style.display === 'none' || moreContent.style.display === '') {
        moreContent.style.display = 'block'
        showMoreBtn.innerHTML = 'Read Less about outsourcing <i class="fa-solid fa-arrow-right"></i>'
    } else {
        moreContent.style.display = 'none'
        showMoreBtn.innerHTML = 'Read More about outsourcing <i class="fa-solid fa-arrow-right"></i>'
    }
})
